import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@/components/atoms";
import { GeneralFooter, GeneralHeader } from "@/components/organisms";
import { KYCVerificationStep, PlatformSetupStep } from "@/components/organisms/Onboarding";

type OnboardingStep = "kyc" | "platform-setup" | "complete";

export const Onboarding = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState<OnboardingStep>("kyc");

  const handleKYCComplete = () => {
    setCurrentStep("platform-setup");
  };

  const handleSetupComplete = () => {
    setCurrentStep("complete");
    // Navigate to root - Home component will route to bookings
    navigate("/");
  };

  return (
    <div className="flex min-h-screen flex-row overflow-hidden">
      <div className="relative flex flex-1 flex-col">
        <GeneralHeader action="logout" />
        <Container className="relative flex w-full max-w-[1040px] flex-1 justify-center gap-5 px-5 py-8">
          {currentStep === "kyc" && <KYCVerificationStep onVerificationComplete={handleKYCComplete} />}
          {currentStep === "platform-setup" && <PlatformSetupStep onSetupComplete={handleSetupComplete} />}
        </Container>
        <GeneralFooter />
      </div>
    </div>
  );
};
